import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [email, setEmail] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Inject Schema.org JSON-LD
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://poliv-almaty.kz';

    const localBusiness = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'ПоливАлматы — Системы автоматического полива',
      description: 'Профессиональный монтаж, проектирование и сервисное обслуживание систем автоматического полива в Алматы и области. Оборудование Hunter, Rain Bird, Gardena. Гарантия 3 года.',
      url: siteUrl,
      telephone: ['+7-705-140-10-00', '+7-705-167-01-77'],
      email: 'indra.irri@gmail.com',
      priceRange: '$$',
      image: `${siteUrl}/og-image.jpg`,
      logo: `${siteUrl}/logo.png`,
      foundingDate: '2015',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Алматы',
        addressRegion: 'KZ-ALA',
        addressCountry: 'KZ',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '43.238293',
        longitude: '76.945465',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '6',
        bestRating: '5',
        worstRating: '1',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
      sameAs: [
        'https://wa.me/77051670177',
        'https://t.me/+79688232355',
      ],
    };

    const webSite = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'ПоливАлматы',
      url: siteUrl,
      description: 'Системы автоматического полива под ключ в Алматы — проектирование, монтаж и обслуживание.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };

    const services = [
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Проектирование систем полива',
        description: 'Разработка индивидуального проекта с учетом ландшафта, типа почвы и растений. 3D-визуализация будущей системы.',
        provider: { '@type': 'LocalBusiness', name: 'ПоливАлматы', url: siteUrl },
        areaServed: { '@type': 'City', name: 'Алматы' },
        serviceType: 'Проектирование систем автоматического полива',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Монтаж и установка систем полива',
        description: 'Профессиональная установка оборудования Hunter, Rain Bird, Gardena. Прокладка магистралей, установка дождевателей и контроллеров.',
        provider: { '@type': 'LocalBusiness', name: 'ПоливАлматы', url: siteUrl },
        areaServed: { '@type': 'City', name: 'Алматы' },
        serviceType: 'Монтаж систем автоматического полива',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Сервисное обслуживание систем полива',
        description: 'Сезонное обслуживание, консервация на зиму, ремонт и модернизация существующих систем. Договоры на постоянное обслуживание.',
        provider: { '@type': 'LocalBusiness', name: 'ПоливАлматы', url: siteUrl },
        areaServed: { '@type': 'City', name: 'Алматы' },
        serviceType: 'Сервисное обслуживание систем полива',
      },
    ];

    const faqPage = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Какое оборудование для полива вы используете?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Мы работаем только с проверенным оборудованием ведущих мировых производителей систем полива: Hunter, Rain Bird и Gardena.',
          },
        },
        {
          '@type': 'Question',
          name: 'Какая гарантия на монтаж системы автоматического полива?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Мы предоставляем гарантию 3 года на все выполненные работы по монтажу и установке систем автоматического полива в Алматы.',
          },
        },
        {
          '@type': 'Question',
          name: 'Сколько времени занимает установка системы полива?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Время установки системы автополива зависит от площади участка и сложности проекта. В среднем монтаж на участке 15–20 соток в Алматы занимает 3–5 дней.',
          },
        },
        {
          '@type': 'Question',
          name: 'Предоставляете ли вы сервисное обслуживание систем полива?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Да, мы заключаем договоры на постоянное сервисное обслуживание, включая сезонный запуск, консервацию системы полива на зиму и плановый ремонт.',
          },
        },
        {
          '@type': 'Question',
          name: 'Сколько стоит установка системы автоматического полива в Алматы?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Стоимость монтажа системы полива зависит от площади участка, количества зон и выбранного оборудования. Свяжитесь с нами для бесплатного расчёта стоимости вашего проекта.',
          },
        },
        {
          '@type': 'Question',
          name: 'Работаете ли вы за пределами Алматы?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Да, мы выполняем монтаж и обслуживание систем полива в Алматы и по всей Алматинской области.',
          },
        },
      ],
    };

    const scripts: HTMLScriptElement[] = [];

    [localBusiness, webSite, ...services, faqPage].forEach((schema) => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.text = JSON.stringify(schema);
      document.head.appendChild(el);
      scripts.push(el);
    });

    return () => {
      scripts.forEach((el) => {
        if (document.head.contains(el)) document.head.removeChild(el);
      });
    };
  }, []);

  // Handle scroll effect for navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setScrolled(window.scrollY > 50);
    });
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 flex items-center justify-center bg-emerald-600 rounded-lg">
                <i className="ri-water-flash-line text-xl text-white"></i>
              </div>
              <span className={`text-xl font-bold ${scrolled ? 'text-gray-900' : 'text-white'}`}>ПоливАлматы</span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
                Услуги
              </button>
              <button onClick={() => scrollToSection('portfolio')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
                Портфолио
              </button>
              <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
                О компании
              </button>
              <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'}`}>
                Контакты
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-white text-gray-900 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Заказать звонок
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden cursor-pointer">
              <i className={`ri-menu-line text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
                Услуги
              </button>
              <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
                Портфолио
              </button>
              <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
                О компании
              </button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
                Контакты
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/60e7ad1446ce33533fc77d7caad8d396.jpg" 
            alt="Система автоматического полива"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-3xl">
            {/* Social Proof */}
            <div className="flex items-center space-x-3 mb-8">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-emerald-500 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-amber-500 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-blue-500 border-2 border-white"></div>
              </div>
              <span className="text-white text-sm font-medium">Более 500 довольных клиентов в Алматы</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight">
              Системы автоматического полива
              <span className="block font-light mt-2">под ключ в Алматы</span>
            </h1>

            <p className="text-white text-lg mb-8 max-w-xl leading-relaxed">
              Проектирование, монтаж и сервисное обслуживание систем полива любой сложности. Гарантия 3 года
            </p>

            <button onClick={() => scrollToSection('contact')} className="bg-white text-gray-900 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer">
              <span>Получить консультацию</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <p className="text-gray-500 text-sm font-medium mb-3 tracking-wider">НАШИ УСЛУГИ</p>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Полный спектр работ
              <span className="block">по системам полива</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-draft-line text-4xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Проектирование систем</h3>
              <p className="text-gray-600 leading-relaxed">
                Разработка индивидуального проекта с учетом ландшафта, типа почвы и растений. 3D-визуализация будущей системы
              </p>
            </div>

            {/* Service 2 */}
            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-tools-line text-4xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Монтаж и установка</h3>
              <p className="text-gray-600 leading-relaxed">
                Профессиональная установка оборудования Hunter, Rain Bird, Gardena. Прокладка магистралей, установка дождевателей и контроллеров
              </p>
            </div>

            {/* Service 3 */}
            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-settings-3-line text-4xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Сервисное обслуживание</h3>
              <p className="text-gray-600 leading-relaxed">
                Сезонное обслуживание, консервация на зиму, ремонт и модернизация существующих систем. Договоры на постоянное обслуживание
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight font-serif">
              Наши проекты
              <span className="block">в Алматы</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Project 1 */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-[4/3] bg-white p-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20automatic%20irrigation%20system%20installed%20in%20private%20residential%20garden%20with%20green%20lawn%20and%20sprinklers%20working%2C%20neat%20landscaping%2C%20professional%20installation%2C%20clean%20simple%20background%2C%20daylight%20photography%2C%20high%20quality&width=800&height=600&seq=port001&orientation=landscape" 
                  alt="Частный дом"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-serif">Частный дом, 15 соток</h3>
                <p className="text-sm text-gray-600">8 зон полива • Hunter оборудование • Автоматический контроллер</p>
              </div>
            </div>

            {/* Project 2 */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-[4/3] bg-white p-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=automatic%20sprinkler%20irrigation%20system%20in%20cottage%20community%20residential%20area%20with%20multiple%20zones%2C%20professional%20landscaping%2C%20modern%20equipment%20installation%2C%20clean%20minimalist%20background%2C%20natural%20daylight%2C%20premium%20quality&width=800&height=600&seq=port002&orientation=landscape" 
                  alt="Коттеджный поселок"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-serif">Коттеджный поселок</h3>
                <p className="text-sm text-gray-600">25 зон полива • Rain Bird система • Центральное управление</p>
              </div>
            </div>

            {/* Project 3 */}
            <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-[4/3] bg-white p-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20irrigation%20system%20on%20sports%20field%20with%20pop-up%20sprinklers%20watering%20perfectly%20maintained%20grass%2C%20athletic%20field%20irrigation%2C%20commercial%20grade%20equipment%2C%20simple%20clean%20background%2C%20bright%20daylight%2C%20high%20quality%20photography&width=800&height=600&seq=port003&orientation=landscape" 
                  alt="Спортивное поле"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-serif">Спортивное поле</h3>
                <p className="text-sm text-gray-600">12 зон полива • Gardena Pro • Программируемый график</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-gradient-to-b from-emerald-900 to-amber-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <div className="inline-block bg-emerald-600 px-4 py-2 rounded-lg mb-6">
              <span className="text-white text-sm font-medium">/ О НАС</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 max-w-3xl leading-tight">
              Эксперты по системам автоматического полива с 2015 года
            </h2>
            <p className="text-amber-100 text-lg max-w-3xl leading-relaxed">
              Мы специализируемся на проектировании и установке систем автополива в Алматы и области. Работаем только с проверенным оборудованием ведущих мировых производителей. Наша команда состоит из сертифицированных специалистов с опытом более 8 лет
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
            <div className="aspect-square rounded-2xl overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20irrigation%20specialists%20team%20working%20on%20automatic%20sprinkler%20system%20installation%2C%20technicians%20in%20uniform%20with%20modern%20equipment%2C%20outdoor%20work%20setting%2C%20natural%20lighting%2C%20teamwork%20and%20professionalism%2C%20high%20quality%20photography&width=800&height=800&seq=about001&orientation=squarish" 
                alt="Наша команда"
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              <div className="text-8xl font-bold text-white mb-4 font-serif">500+</div>
              <p className="text-amber-100 text-xl mb-8 leading-relaxed">
                Успешно реализованных проектов в Алматы и Алматинской области
              </p>
              <button onClick={() => scrollToSection('contact')} className="bg-white text-gray-900 px-8 py-3 rounded-full text-base font-semibold hover:bg-gray-100 transition-colors inline-flex items-center whitespace-nowrap cursor-pointer">
                Наши преимущества
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-2 h-2 bg-emerald-600 rounded-full"></div>
              <span className="text-gray-500 text-sm font-medium tracking-wider">ОТЗЫВЫ КЛИЕНТОВ</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-4">
              Что говорят наши
              <span className="block">клиенты о нас</span>
            </h2>
            <p className="text-gray-600 text-lg">Реальные отзывы владельцев систем полива</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Отличная работа команды</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Установили систему полива на участке 20 соток. Все сделали быстро и качественно. Газон теперь всегда зеленый, даже в жару. Очень доволен!
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-emerald-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Алексей Петров</div>
                  <div className="text-sm text-gray-600">Владелец частного дома</div>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Профессиональный подход</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Сначала сделали детальный проект с 3D-визуализацией, потом установили все точно по плану. Система работает безупречно уже второй сезон.
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-blue-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Марина Ким</div>
                  <div className="text-sm text-gray-600">Владелица коттеджа</div>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Надежное обслуживание</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Заключили договор на сервисное обслуживание. Приезжают вовремя, делают консервацию на зиму и запуск весной. Все четко и профессионально.
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-amber-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Дмитрий Сергеев</div>
                  <div className="text-sm text-gray-600">Управляющий ТСЖ</div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Testimonial 4 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Экономия воды и времени</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Раньше тратил по 2 часа каждый день на полив. Теперь система все делает сама. Расход воды снизился на 40%. Окупилась за один сезон!
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-purple-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Сергей Иванов</div>
                  <div className="text-sm text-gray-600">Владелец участка</div>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Качественное оборудование</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Использовали оборудование Hunter. Все работает идеально, ни одной поломки за 3 года. Гарантийное обслуживание тоже на высоте.
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-rose-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Анна Смирнова</div>
                  <div className="text-sm text-gray-600">Владелица дачи</div>
                </div>
              </div>
            </div>

            {/* Testimonial 6 */}
            <div className="bg-white p-8 rounded-2xl">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Рекомендую всем</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Лучшее решение для тех, кто хочет красивый газон без лишних хлопот. Цена полностью оправдана качеством работы и результатом.
              </p>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-teal-500 rounded-full"></div>
                <div>
                  <div className="font-bold text-gray-900">Олег Казаков</div>
                  <div className="text-sm text-gray-600">Владелец загородного дома</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact/CTA Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Готовы установить систему полива?
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Оставьте заявку, и мы свяжемся с вами в течение 15 минут для бесплатной консультации
          </p>
          <button onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })} className="bg-amber-900 text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-amber-800 transition-colors inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer">
            <span>Заказать звонок</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </button>

          {/* Partner Logos */}
          <div className="mt-20 pt-12 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-8 uppercase tracking-wider">Официальные партнеры</p>
            <div className="flex flex-wrap justify-center items-center gap-12">
              <div className="text-3xl font-bold text-gray-400">HUNTER</div>
              <div className="text-3xl font-bold text-gray-400">RAIN BIRD</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="py-24 bg-gray-50">
        <div className="max-w-2xl mx-auto px-6">
          <div className="bg-white p-10 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-bold text-gray-900 mb-2">Заказать консультацию</h3>
            <p className="text-gray-600 mb-8">Заполните форму, и наш специалист свяжется с вами</p>
            
            <form 
              data-readdy-form 
              id="consultation-form" 
              className="space-y-6"
              action="https://readdy.ai/api/form/d5tc8do396gdsp2ho350"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                const originalText = submitButton.textContent;
                
                try {
                  submitButton.disabled = true;
                  submitButton.textContent = 'Отправка...';
                  
                  const response = await fetch('https://readdy.ai/api/form/d5tc8do396gdsp2ho350', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(formData as any).toString(),
                  });
                  
                  if (response.ok) {
                    submitButton.textContent = '✓ Заявка отправлена!';
                    submitButton.classList.add('bg-green-600');
                    form.reset();
                    setTimeout(() => {
                      submitButton.textContent = originalText;
                      submitButton.classList.remove('bg-green-600');
                      submitButton.disabled = false;
                    }, 3000);
                  } else {
                    throw new Error('Ошибка отправки');
                  }
                } catch (error) {
                  submitButton.textContent = '✗ Ошибка. Попробуйте снова';
                  submitButton.classList.add('bg-red-600');
                  setTimeout(() => {
                    submitButton.textContent = originalText;
                    submitButton.classList.remove('bg-red-600');
                    submitButton.disabled = false;
                  }, 3000);
                }
              }}
            >
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Ваше имя</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm"
                  placeholder="Введите ваше имя"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Телефон</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm"
                  placeholder="+7 (___) ___-__-__"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label htmlFor="area" className="block text-sm font-medium text-gray-700 mb-2">Площадь участка (соток)</label>
                <input 
                  type="text" 
                  id="area" 
                  name="area"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm"
                  placeholder="Например: 15"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Комментарий</label>
                <textarea 
                  id="message" 
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm resize-none"
                  placeholder="Расскажите о вашем проекте..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Максимум 500 символов</p>
              </div>

              <button 
                type="submit"
                className="w-full bg-emerald-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Отправить заявку
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16 mx-6 mb-6 rounded-3xl">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            {/* Newsletter */}
            <div>
              <h3 className="text-3xl font-light mb-4">Получайте советы по уходу за газоном</h3>
              <p className="text-gray-400 mb-6">Подпишитесь на нашу рассылку</p>
              <form 
                data-readdy-form 
                id="newsletter-form" 
                className="flex flex-col sm:flex-row gap-3"
                action="https://readdy.ai/api/form/d5tc8do396gdsp2ho35g"
                method="POST"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                  const originalHTML = submitButton.innerHTML;
                  
                  try {
                    submitButton.disabled = true;
                    submitButton.innerHTML = '<span>Отправка...</span>';
                    
                    const response = await fetch('https://readdy.ai/api/form/d5tc8do396gdsp2ho35g', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                      },
                      body: new URLSearchParams(formData as any).toString(),
                    });
                    
                    if (response.ok) {
                      submitButton.innerHTML = '<span>✓ Подписка оформлена!</span>';
                      submitButton.classList.add('bg-green-600');
                      form.reset();
                      setEmail('');
                      setTimeout(() => {
                        submitButton.innerHTML = originalHTML;
                        submitButton.classList.remove('bg-green-600');
                        submitButton.disabled = false;
                      }, 3000);
                    } else {
                      throw new Error('Ошибка отправки');
                    }
                  } catch (error) {
                    submitButton.innerHTML = '<span>✗ Ошибка</span>';
                    submitButton.classList.add('bg-red-600');
                    setTimeout(() => {
                      submitButton.innerHTML = originalHTML;
                      submitButton.classList.remove('bg-red-600');
                      submitButton.disabled = false;
                    }, 3000);
                  }
                }}
              >
                <input 
                  type="email" 
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Ваш email"
                  className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                />
                <button 
                  type="submit"
                  className="bg-white text-gray-900 px-6 py-3 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors inline-flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                >
                  <span>Подписаться</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Навигация</h4>
              <div className="space-y-3">
                <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm font-medium text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                  Услуги
                </button>
                <button onClick={() => scrollToSection('portfolio')} className="block w-full text-left text-sm font-medium text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                  Портфолио
                </button>
                <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm font-medium text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                  О компании
                </button>
                <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm font-medium text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                  Контакты
                </button>
              </div>
            </div>

            {/* Contacts */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Контакты</h4>
              <div className="space-y-3 mb-6">
                <a href="tel:+77051401000" className="block text-gray-400 hover:text-white transition-colors">
                  +7 (705) 140-10-00
                </a>
                <a href="tel:+77051670177" className="block text-gray-400 hover:text-white transition-colors">
                  +7 (705) 167-01-77
                </a>
                <a href="mailto:indra.irri@gmail.com" className="block text-gray-400 hover:text-white transition-colors">
                  indra.irri@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex space-x-6">
              <a href="https://wa.me/77271234567" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                WhatsApp
              </a>
              <a href="https://t.me/polivalmaty" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                Telegram
              </a>
            </div>

            <div className="text-gray-400 text-sm text-center">
              © 2025 Системы полива Алматы. Все права защищены
            </div>

            <div className="flex space-x-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors underline text-sm">
                Политика конфиденциальности
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors underline text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Contact Buttons */}
      <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-40">
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/77051670177"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
          aria-label="Написать в WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>

        {/* Telegram Button */}
        <a
          href="https://t.me/+79688232355"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
          aria-label="Написать в Telegram"
        >
          <i className="ri-telegram-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}